// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// Only the fields required for Firebase Auth (used to get ID tokens for
// calling Cloud Functions) are kept active. The rest is commented out.
const firebaseConfig = {
  apiKey: "AIzaSyD4yTTpoi3jgUieRkb69Pd9NplLukVLzFQ",
  authDomain: "elisyanwealth.firebaseapp.com",
  projectId: "elisyanwealth",
  // storageBucket: "elisyanwealth.appspot.com",
  // messagingSenderId: "1055096900240",
  appId: "1:1055096900240:web:85d8bb9146a8c61e076615",
  // measurementId: "G-GNT0QV4W7K",
  // databaseId: "code-access"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// export const firestore = getFirestore(app,'code-access');
export const auth = getAuth(app);

